import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastSubject = new BehaviorSubject<{ message: string } | null>(null);
  toast$ = this.toastSubject.asObservable();

  showToast(message: string) {
    this.toastSubject.next({ message });
    setTimeout(() => this.toastSubject.next(null), 100000);
  }
}
